export function Hero() {
  return (
    <section className="relative flex min-h-screen items-center overflow-hidden">
      {/* Realistic construction site photo from Pexels */}
      <img
        src="https://images.pexels.com/photos/2760243/pexels-photo-2760243.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=1200&w=2000&fm=webp"
        srcSet="
          https://images.pexels.com/photos/2760243/pexels-photo-2760243.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=600&w=1000&fm=webp 1000w,
          https://images.pexels.com/photos/2760243/pexels-photo-2760243.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=1200&w=2000&fm=webp 2000w
        "
        sizes="100vw"
        alt="Large construction site with cranes and heavy machinery"
        width={2000}
        height={1200}
        loading="eager"
        // @ts-ignore
        fetchPriority="high"
        className="absolute inset-0 h-full w-full object-cover object-center"
        style={{ contentVisibility: 'auto' }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950/90 via-slate-950/65 to-slate-900/25" />
      {/* subtle grid accent */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.18] [background-image:linear-gradient(rgba(45,212,191,0.15)_1px,transparent_1px),linear-gradient(90deg,rgba(45,212,191,0.15)_1px,transparent_1px)] [background-size:64px_64px]" />

      <div className="relative mx-auto w-full max-w-7xl px-6 pt-28 pb-24 sm:pt-36 sm:pb-32 lg:pt-40 lg:pb-36">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-sm border border-teal-400/40 bg-teal-500/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.25em] text-teal-300 backdrop-blur">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-teal-400" />
            Advanced Engineering Since 1976
          </span>
          <h1 className="mt-6 text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-6xl lg:text-7xl">
            ENGINEERING THE FUTURE.
            <span className="mt-2 block bg-gradient-to-r from-teal-300 via-cyan-200 to-white bg-clip-text text-transparent">
              PRECISION AT SCALE.
            </span>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-200/85 sm:text-lg">
            Advanced Construction Machinery for a Global Landscape — trusted by
            contractors across 40+ countries for batching plants, concrete
            mixers, and heavy construction equipment.
          </p>
          <div className="mt-9 flex flex-wrap gap-4 sm:flex-row sm:items-center">
            <a
              href="#solutions"
              className="group inline-flex items-center justify-center gap-2 rounded-md bg-teal-500 px-6 py-3 text-sm font-bold text-slate-950 shadow-sm transition hover:bg-teal-400"
            >
              Explore Products
              <svg className="h-4 w-4 transition group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14m-6-6 6 6-6 6" />
              </svg>
            </a>

          </div>

          <div className="mt-12 grid max-w-2xl grid-cols-3 gap-4 border-t border-white/15 pt-8 sm:gap-8">
            {[
              ["48+", "Years of Engineering"],
              ["40+", "Countries Served"],
              ["1.2K+", "Machines Deployed"],
            ].map(([num, label]) => (
              <div key={label}>
                <div className="text-2xl font-bold text-teal-300 sm:text-3xl">{num}</div>
                <div className="mt-1 text-[0.65rem] uppercase tracking-wide text-slate-300 sm:text-xs">
                  {label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* scroll cue */}
      <div className="absolute bottom-6 left-1/2 hidden -translate-x-1/2 flex-col items-center gap-2 text-white/50 sm:flex">
        <span className="text-[0.6rem] uppercase tracking-[0.3em]">Scroll</span>
        <span className="h-8 w-px bg-gradient-to-b from-teal-300 to-transparent" />
      </div>
    </section>
  );
}
